import DomHandler, { DomNode } from 'domhandler';
import { Parser } from 'htmlparser2';
import React, { createElement, ElementType, ReactNode } from 'react';
import { insertHtmlEntities } from '../../utils/insertHtmlEntities';
import { parseBrandName } from './brandNameParser';
import { tagToComponent } from './tagToComponentMapping';

interface WarningProps {
  children: ReactNode;
  [x: string]: any;
}

const Warning = (type: string) => ({ children, ...props }: WarningProps) => (
  <div {...props}>
    {process.env.NODE_ENV !== 'production' && (
      <span style={{ color: 'red', textTransform: 'uppercase' }}>{type}</span>
    )}
    {children}
  </div>
);

const renderNode = (
  { attribs, children, name, type, data }: DomNode,
  i: number
): ReactNode => {
  if (type === 'tag') {
    const { href, class: className, ...attrs } = attribs;
    const tag: keyof typeof tagToComponent = name as any;
    const Element: ElementType = tagToComponent[tag] || Warning(name);
    return createElement(
      Element,
      {
        ...attrs,
        to: href || null,
        href,
        className,
        key: i
      },
      // images do not have children, thus react will throw an error if we call children.map on them
      tag === 'img' ? null : children.map(renderNode)
    );
  }

  return insertHtmlEntities(data);
};

const ParseHtml = (html: string = ''): ReactNode => {
  const handler = new DomHandler((error: any) => {
    if (error) {
      console.log('ERROR: ', error);
    }
    // else console.log('PARSING DONE');
  });

  html = parseBrandName(html || '');

  const parser = new Parser(handler, { decodeEntities: true });
  parser.parseComplete(html);

  const htmlObj: DomNode[] = handler.dom;

  return htmlObj.map(renderNode);
};

export default ParseHtml;
